<template>
  <div class="container no-margin">
    <number-input
      placeholder="Ej: 1143464800"
      label="Celular"
      name="celular"
      maxlength="10"
      subhint="Ingresá el número sin el 0 y sin el 15"
      v-model="value.numero"
      :required="required"
      :validationError="validationError"
      :scroll-on-focus="scrollOnFocus"
      @input="onInput"
      @click="trackClick('numeroCelular')"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import NumberInput from "@/components/core/NumberInput";
import { DO_CLICK_TRACKING } from "@/config/constants/action-types";

export default {
  name: "MobileNumber",
  components: { NumberInput },
  props: {
    label: String,
    value: Object,
    name: String,
    scrollOnFocus: {
      type: Boolean,
      default: true
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validationError: null,
      checked: false
    };
  },
  methods: {
    onInput() {
      if (this.checked) {
        this.isValid(this.value.numero);
      }
    },

    checkValid() {
      this.checked = true;
      return this.isValid(this.value.numero);
    },
    isValid(val) {
      const isNumberValid = !isNaN(parseFloat(val)) && isFinite(val);

      if (isNumberValid && val.length >= 8 && val.length <= 10) {
        this.validationError = null;
      } else {
        this.validationError =
          val.length > 0
            ? "El número no es válido"
            : "Tenés que ingresar este dato";
        return false;
      }
      return true;
    },
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(DO_CLICK_TRACKING, el);
    }
  }
};
</script>
